export type thumbnailSize = "low" | "medium" | "high" | "maximum";

export function getYoutubeVideoThumbnail(videoId: string, size: thumbnailSize) {
  const imgSizeObj = {
    low: "sddefault",
    medium: "mqdefault",
    high: "hqdefault",
    maximum: "maxresdefault",
  };
  const imageSize = imgSizeObj[size];
  return `https://img.youtube.com/vi/${videoId}/${imageSize}.jpg`;
}

export const isValidYoutubeVideo = async (videoId: string) => {
  try {
    const res = await fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`);
    return res.ok;
  } catch (error) {
    return false;
  }
};
